import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = 'category';

export type categoryType = {
    category_name: string;
}

export type categoryList = {
    keyword?: string;
    start_date?: string;
    end_date?: string;
    limit?: number;
    page?: number;
    sortBy?: string;
    sortType?: string;
}
export class CategoryApi extends BaseAPI {
    static list(query: categoryList): Promise<AxiosResponse> {
        return this.api.get(`${path}`, { params: { ...query } })
    }
    static create(body: categoryType): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
    static update(id_category: number, body: categoryType): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_category}`, body)
    }
    static delete(id_category: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_category}`)
    }
    static findOne(id_category: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/${id_category}`)
    }
}